export const api = {
  checkMerchant: '/api/team/check-merchant',
  signin: '/api/user/signin',
  signup: '/api/team/signup',
  verifyMerchant: '/api/team/verify-merchant',
  changePassword: '/api/user/change-password',
  sendOtp: '/api/user/send-otp',
  verifyOtp: '/api/user/verify-otp',
  getMerchant: '/api/user/getUserByid',
  getMerchantTeam: '/api/merchant/team',
  pincode: '/api/pincode',
  startKYC: '/api/merchant/start-kyc',
  contactInfo: '/api/merchant/contact-info',
  busninessInformation: '/api/merchant/business-information',
  businessIdentity: '/api/merchant/business-identity',
  accountDetails: '/api/merchant/bank-account-details',
  documentsUpload: '/api/merchant/documents-upload',
  orders: '/api/orders/all',
  upload: '/api/utility/upload',
  refund: '/api/refund/initiate',
  transactionsData: '/api/transaction/all',
  customersData: '/api/customer/all',
  permissionsData: '/api/user/permissions',
  addPermission: '/api/user/add_permission',
  rolesData: '/api/user/roles',
  addRole: '/api/user/roles/add',
  updateRole: '/api/user/roles/update',
  merchantCred: '/api/merchant/cred/',
  merchantABCTemplate: '/api/merchant/template/',
  merchantDiscount: '/api/merchant/merchant-discount/',
  merchantDiscountAll: '/api/merchant/merchant-discount/all/',
  merchantOnboarding: '/api/merchant/onboard',
  updateRtoModelConfig: '/api/merchant/rto-risk-threshold-update',
  updateRtoRatingConfig: '/api/rto/rto-rating-update',
  updateRtoKlothoConfig: '/api/merchant/rto-klotho-config-update',
  updateRtoAlertsConfig: '/api/merchant/update-rto-alerts-config',
  updateAddressSurfaceConfig: '/api/merchant/address-config-update',
  retryRefund: '/api/refund/retry',
  settlementStatus: '/api/settlement/check-status',
  refundStatus: '/api/refund/check-status',
  transactionStatus: '/api/transaction/status-check',
  settlementRetry: '/api/settlement/retry',
  dangledTransactionRefund: '/api/refund/dangle-transaction',
  mannualLedger: '/api/settlement/get-manual-ledger',
  updateManualLedger: '/api/settlement/update-manual-ledger',
  dangleTransactions: '/api/transaction/dangle',
  paymentProviderSwitch: '/api/transaction/payment-provider-switch',
  paymentProviders: '/api/transaction/payment-providers',
  paymentMSConfig: '/api/merchant/ms-config',
  addressAnnotation: '/api/address/annotation',
  controlSegmentUpdate: '/api/merchant/control-segment-config-update',
  addressConfig: '/api/address/annotation/config',
  processRefund: '/api/refund/process',
  autoRefundTransactions: '/api/transaction/auto-refund-transactions',
  submitAutoRefund: '/api/transaction/submit-auto-refund',
  logout: '/api/user/logout',
  merchantList: '/api/merchant/merchantList',
  orderAnalytics: '/api/orders/order-analytics',
  inviteTeam: '/api/merchant/inviteTeam',
  reportsList: '/api/reports/merchantReports',
  reportFilters: '/api/reports/reportFilters',
  generateReport: '/api/reports/generateReport',
  bulkRefundUpdateStatus: '/api/refund/bulk-check-status',
  config: {
    discount: '/api/merchant/discount-config-update',
    dashboard: '/api/merchant/dashboard-config-update',
    allConfig: '/api/dashboard/get-all-config',
    configList: '/api/dashboard/get-config-count',
    configMerchantList: '/api/dashboard/get-config-merchant-list',
    shopifyApp: '/api/shopify-app/update-config',
    shopifyAppNonPlusPrepaidDiscount: '/api/shopify-app/non-plus/prepaid-discount'
  },
  merchantConfig: '/api/merchant/merchant-config',
  updateInternalConfig: '/api/merchant/internal-config-update',
  getRewardMerchantConfig: '/api/reward/merchants',
  updateRewardMerchantConfig: '/api/reward/merchants',
  merchantHealth: '/api/shopify/merchant-health',
  teamList: '/api/merchant/teamList',
  invitedTeamlist: '/api/merchant/invitedTeamList',
  updateTeam: '/api/merchant/updateTeam',
  getWebhooks: '/api/webhook_config/all',
  addWebhook: '/api/webhook_config/add',
  updateWebhook: '/api/webhook_config/update',
  updateV2PaymentWebhooksEnabled: '/api/webhook_config/enable-webhooks',
  getRTORiskThresholdValues: '/api/merchant/get-rto-risk-threshold-values',
  getRTOConfigChangeLogs: '/api/merchant/get-rto-config-change-logs',
  netbankingMapping: '/api/payment/provider-mapping',
  cardNetworkConfig: '/api/payment/card-network-config',
  paymentProviderModel: '/api/payment/payment-provider-model',
  paymentDowntimeData: '/api/payment/payment-alerts',
  stateList: `/api/states/listOfstates`,
  paymentConfigUpdate: '/api/payment/payment-config',
  timeline: {
    all: '/api/timeline/all',
    filters: '/api/timeline/filters',
  },
  ppcodConfig: '/api/payment/config',
  getAwbStatus: '/api/rto/get-awb-status',
  updateAwbStatus: '/api/rto/update-awb-status',
  fetchUtmList: '/api/orders/utm-list',
  getPhoneStatus: '/api/rto/get-phone-no-status',
  rateCapture: {
    agreement: '/api/onboarding/agreement',
  },
  billing: {
    pricingReport: '/api/onboarding/agreement/download_pricing_strategies',
  },
  fileS3PreSignedUrl: '/api/pincode/presigned-url',
  fileS3UploadNotifyUrl: '/api/pincode/upload/file',
  pincodeFileDownloadUrl: '/api/pincode/download/file',
  getPreLiveQc : '/api/qc/pre-live-qc',
  updatePaymentLinksConfig: '/api/merchant/payment-links-config',
  getPaymentLinksConfig: '/api/merchant/payment-links-config',
  getProviderList: '/api/notification/templates/provider-list',
  getActiveOTPProvider: '/api/notification/templates/active',
  getMerchantConfig: '/api/notification/merchant-configs',
  updateOTPForAll: '/api/notification/merchant-configs',
  updateOTPProvider: '/api/notification/templates/re-route',
  getActiveTransactionalProvider: '/api/notification/templates/active',
  updateTransactionalProvider: '/api/notification/templates/re-route',
  downloadKycDocuments: '/api/config/download-kyc-docs',
  toggleRiskBasedPPCODConfig:'/api/rto/risk-based-ppcod-toggle',
  getAddress:'/api/customer/address/get',
  syncCustomer:'/api/merchant/sync-merchant',
  rtoDashboardConfigs:'/api/rto/rto-dashboard-configs',
  updateBasicConfig: '/api/merchant/basic-config-update',
  globalConfig: '/api/payment/global-config',
  updateKwikFlowsTierConfig: '/api/rto/kwikflow-tier-config-update',
};
